var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _rect2, _rect3, _rect4, _rect5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargingStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ag{fill:#1cb15f}.ah{fill:#3f4349}.ai{fill:#ff9a01}.aj{fill:#c3313c}.am{fill:#0f9452}.an{fill:#ffc239}.ao{fill:#4a4b4c}.ap{fill:#92252d}.as{fill:#393a3a}.av{fill:#63231b}.ax{fill:#98bcf9}"))), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h10v40H52z",
    className: "ag"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.239 22H62v37h-3a4.882 4.882 0 0 1-4.88-4.88v-30c0-1.17.95-2.12 2.12-2.12Z",
    style: {
      fill: "#27d674"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 14h-3l2-12h-2l-8 15h6l-1 10h1l5-13z",
    style: {
      fill: "#fbcb00"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30 27 5-13h3l-5 13h-3zM35 14l2-12h-3l-2 12h3z",
    className: "ai"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2ZM59 31h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2ZM59 28h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2Z",
    className: "am"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 36a2 2 0 0 1 2 2v5h-4v-5a2 2 0 0 1 2-2Z",
    className: "ag"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57 36a2 2 0 0 1 2 2v4h-4v-4a2 2 0 0 1 2-2Z",
    style: {
      fill: "#52de90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.956 56h-5.912A3.047 3.047 0 0 1 46 52.957v-4.913c0-.575-.469-1.043-1.044-1.043H36v-2h8.956A3.047 3.047 0 0 1 48 48.044v4.913c0 .575.469 1.043 1.044 1.043h5.912c.575 0 1.044-.468 1.044-1.043V42h2v10.957A3.047 3.047 0 0 1 54.956 56Z",
    style: {
      fill: "#2b2e33"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.597,
    cy: 39.002,
    rx: 0.549,
    ry: 1.105,
    style: {
      fill: "#f4dad7"
    },
    transform: "rotate(-70.423 4.596 39.002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.1,
    cy: 46.553,
    rx: 0.759,
    ry: 1.527,
    style: {
      fill: "#fff3d7"
    },
    transform: "rotate(-21.445 4.1 46.552)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.012 56.002V61a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-2.998l8-2Z",
    className: "as"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.713 58.738c-.621 0-1.125.504-1.125 1.125v.075c0 .621.504 1.125 1.125 1.125h5.286c.001-.022.013-.041.013-.063v-2.262h-5.299Z",
    className: "ao"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 56.002V61a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.998l-8-2Z",
    className: "as"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.143 47.183a5.995 5.995 0 0 1 1.614-2.938L8 40.002h28.012l4.243 4.243a6 6 0 0 1 1.757 4.243v7.515a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.515c0-.442.049-.879.143-1.304",
    style: {
      fill: "#6e1c22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.012 40.002-2.088-6.265a4 4 0 0 0-3.795-2.735H13.883a4.001 4.001 0 0 0-3.795 2.735L8 40.002h28.012Z",
    style: {
      fill: "#5490f5"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.286 41.716 2 41.002v-3h6v2l-1.714 1.714zM40.255 44.244l-4.243-4.243H9l-2.243 2.243A5.999 5.999 0 0 0 5 46.486v7.515a2 2 0 0 0 2 2h35.012v-7.515a6.003 6.003 0 0 0-1.757-4.243Z",
    className: "ap"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.129 31.002h-2.365L9.136 36.594 8 40.002h7.464l18.191-6.884a3.998 3.998 0 0 0-3.526-2.116Z",
    className: "ax"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.678 58.738c-.621 0-1.125.504-1.125 1.125v.075c0 .621.504 1.125 1.125 1.125h5.286c.001-.022.013-.041.013-.063v-2.262H4.678Z",
    className: "ao"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m40.255 44.244-4.243-4.243H8l-4.243 4.243c-.074.074-.134.158-.204.235L15 48.001v1h5l2 2 2-2h5.012v-1l11.454-3.524c-.07-.078-.137-.159-.211-.233Z",
    className: "aj"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.099 47.418a5.988 5.988 0 0 1 1.446-2.94l9.94 3.058-1.05 1.575a2 2 0 0 1-1.664.891H5.84a4.003 4.003 0 0 1-3.742-2.584Z",
    className: "b`"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.349 46.487a5.984 5.984 0 0 1 1.196-2.01l9.128 2.809-.238.358a2 2 0 0 1-1.664.891H5.84c-1.5 0-2.807-.826-3.491-2.047Z",
    className: "an"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8 38.002H2.868v1.167c0 .557.402 1.032.951 1.123l2.686.448c.407.068.822-.065 1.114-.357.244-.244.381-.575.381-.92v-1.461Z",
    className: "aj"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m11 58.002 2.4-3.2c.378-.504.97-.8 1.6-.8h14.012c.63 0 1.222.296 1.6.8l2.4 3.2H11Z",
    className: "as"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m33.012 58.002-2.25-3H18.447c-.63 0-2.669.296-3.047.8l-1.65 2.2h19.262Z",
    className: "ao"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 5,
    y: 53.002,
    className: "av",
    rx: 0.5,
    ry: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m37.726 41.716 4.286-.714v-3h-6v2l1.714 1.714z",
    className: "ap"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m25.924 40.002 8.804-3.852-.536-1.609-14.263 5.461h5.995z",
    className: "ax"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.912 47.418a5.988 5.988 0 0 0-1.446-2.94l-9.94 3.058 1.05 1.575a2 2 0 0 0 1.664.891h4.93c1.71 0 3.17-1.074 3.742-2.584Z",
    className: "b`"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.661 46.487a5.984 5.984 0 0 0-1.196-2.01l-9.128 2.809.238.358a2 2 0 0 0 1.664.891h4.93c1.5 0 2.807-.826 3.491-2.047Z",
    className: "an"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.844 38.038v.772c0 .23.091.451.254.614l1.144 1.144c.198.198.48.289.757.242l3.014-.502v-2.307h-5.161c0 .013-.007.024-.007.036Z",
    className: "aj"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 35.012,
    y: 53.002,
    className: "av",
    rx: 0.5,
    ry: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 56,
    y: 44,
    className: "ah",
    rx: 1,
    ry: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 46,
    y: 48,
    className: "ah",
    rx: 1,
    ry: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 48,
    y: 54,
    className: "ah",
    rx: 1,
    ry: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 53h4v2H5zM35 53h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 21H52a1 1 0 0 0-1 1v32h-1.956A1.045 1.045 0 0 1 48 52.957v-4.913a3.047 3.047 0 0 0-3.044-3.043h-2.89a7.008 7.008 0 0 0-1.116-1.464l-1.154-1.154 2.369-.395a1 1 0 0 0 .836-.986v-3a1 1 0 0 0-1-1h-5.946l-1.193-3.582a4.993 4.993 0 0 0-4.743-3.418H13.883A4.993 4.993 0 0 0 9.14 33.42l-1.193 3.582H2a1 1 0 0 0-1 1v3a1 1 0 0 0 .836.986l2.369.395-1.154 1.154a6.989 6.989 0 0 0-1.882 3.427 7.037 7.037 0 0 0-.168 1.523v12.515c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-2h22v2c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V48.487c0-.506-.058-1.002-.162-1.485h2.118c.575 0 1.044.468 1.044 1.043v4.913a3.047 3.047 0 0 0 3.044 3.043h1.956v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM40.096 45.632c.357.51.606 1.079.751 1.681A3.012 3.012 0 0 1 38.158 49h-4.93a.998.998 0 0 1-.832-.446l-.306-.459 8.006-2.464ZM41 39v1.153l-2.943.491L37 39.587v-.586h4Zm-29.964-4.949A2.998 2.998 0 0 1 13.883 32h16.234c1.293 0 2.437.824 2.847 2.051L34.613 39H32a1 1 0 1 0 0 2h3.586l3.003 3.004-9.883 3.041a1 1 0 0 0-.706.956h-4a.996.996 0 0 0-.707.293L22 49.587l-1.293-1.293a.997.997 0 0 0-.707-.293h-4a1 1 0 0 0-.706-.956l-9.883-3.041L8.414 41h19.635a1 1 0 1 0 0-2H9.387l1.649-4.949Zm.874 14.044-.306.459a.998.998 0 0 1-.832.445h-4.93a3.012 3.012 0 0 1-2.694-1.698 5.006 5.006 0 0 1 .757-1.67l8.005 2.463ZM3 40.152v-1.153h4v.586l-1.057 1.057L3 40.151Zm6 20.847H3v-2.184c.314.112.648.184 1 .184h5v2Zm4-4 1.201-1.601a1 1 0 0 1 .799-.399h14c.313 0 .612.149.8.4l1.2 1.6H13Zm22 4v-2h5c.352 0 .686-.072 1-.184v2.184h-6Zm5-4h-6.5l-2.1-2.8a3.014 3.014 0 0 0-2.4-1.2H15a3.01 3.01 0 0 0-2.399 1.2l-2.1 2.8H4c-.552 0-1-.449-1-1v-5.892c.82.567 1.807.892 2.842.892h4.93c1.005 0 1.938-.5 2.496-1.335l.637-.955.095.029v.261a1 1 0 0 0 1 1h4.586l1.707 1.707a.997.997 0 0 0 1.414 0l1.707-1.707H29a1 1 0 0 0 1-1v-.261l.095-.029.637.955A2.996 2.996 0 0 0 33.228 51h4.93A4.999 4.999 0 0 0 41 50.108V56c0 .551-.448 1-1 1Zm21 4h-8v-5h1.956A3.047 3.047 0 0 0 58 52.956v-9.957h1a1 1 0 0 0 1-1v-4c0-1.654-1.346-3-3-3s-3 1.346-3 3v4a1 1 0 0 0 1 1h1v9.957c0 .575-.469 1.043-1.044 1.043H53V23h8v38Zm-5-20v-3a1.001 1.001 0 0 1 2 0v3h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.259 27.671A1 1 0 0 0 29 28h4c.414 0 .785-.255.934-.641l5-13A1.002 1.002 0 0 0 38.001 13h-1.82l1.806-10.835A1 1 0 0 0 37 1h-5c-.369 0-.709.204-.883.529l-8 15a.999.999 0 0 0 .882 1.47h4.895l-.89 8.9c-.028.281.064.561.254.771ZM32.314 26h-.857l4.231-11h.857l-4.23 11Zm2.534-23h.972l-1.666 10h-.972l1.666-10Zm-9.18 13 6.933-13h.22l-1.806 10.835A1 1 0 0 0 32.002 15h1.544l-3.16 8.216.611-6.116a1.001 1.001 0 0 0-.995-1.1h-4.333ZM55 34h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2ZM55 31h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2ZM55 28h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingStation);
export default __webpack_public_path__ + "static/media/charging-station.bb0b4b5b21657a1aecc24af424b52d10.svg";
export { ForwardRef as ReactComponent };